module.exports = __webpack_public_path__ + "static/media/store-exterior.e52e1538.jpg";